export interface IVisitorEmail {
    address: string;
}
